import React from 'react'
import styled from '@emotion/styled'
import { mq } from '../../../helpers'
import PressLogos from '../../about-us/PressLogos'

// Renamed from PressWrapper to avoid the name collision with
// components/about-us/styles' PressWrapper (used inside PressLogos itself).
const PressSectionWrapper = styled.div`
  width: 100%;
  padding: 72px 0;
  max-width: 1600px;

  ${mq('max', '768px')} {
    padding: 50px 16px;
  }
`

const PressSection = () => (
  <PressSectionWrapper>
    <PressLogos />
  </PressSectionWrapper>
)

export default PressSection
